import { isMongoObjectId } from "./phone";

/** Strip client UUIDs before PATCH; keep only valid MongoDB _id values. */
export const sanitizeImagesForApi = (images = []) =>
  images.map(({ _id, image, title, is_admin }) => {
    const entry = {
      image: image ?? "",
      title: title ?? "",
      is_admin: is_admin ?? false,
    };

    if (isMongoObjectId(_id)) {
      entry._id = _id;
    }

    return entry;
  });
